<!-- <page-header title="UPDATE_COMPOUND"></page-header> -->

<div class="m-3">
  <app-tabset [transparent]="true" (tabChange)="onTabChange($event)">
    <app-tab id="general" name="GENERAL" [active]="tab === 'general'">
      <app-update-compound-general></app-update-compound-general>
    </app-tab>
    <app-tab id="documents" name="DOCUMENTS" [active]="tab === 'documents'">
      <app-update-compound-documents></app-update-compound-documents>
    </app-tab>
    <app-tab
      id="payments"
      name="PAYMENTS"
      *ngxPermissionsOnly="['LICENSE_TAB_PAYMENTS']"
      [active]="tab === 'payments'"
    >
      <app-update-compound-payments
        *ngIf="tab === 'payments'"
      ></app-update-compound-payments>
    </app-tab>
  </app-tabset>
</div>
